<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      <div class="pushlist container">
        <ul v-if="!notifyLogs.length" class="group flex_top">
          <li class="headpic"><img src="images/headpic_linenotify.jpg" /></li>
          <li class="content">
            <div class="from">LINE Notify</div>
            <div class="message editor">
              尚無推播通知紀錄
              <!-- ↑class="message 補上editor" -->
              <!-- ↓若無綁定再出現Line Notify圖 -->

              <!-- <p align="center"><a href="notify.html"><img src="images/line_notify_square.png"></a></p> -->
              <!-- 若無綁定再出現 -->
            </div>
            <!-- <time>2020-01-03 12:00</time> -->
          </li>
        </ul>

        <ul
          v-for="(log, index) in notifyLogs"
          :key="index"
          class="group flex_top"
        >
          <!-- <li class="headpic"><img :src="log.portalLogo" /></li> -->
          <li class="headpic">{{ log.shopName.charAt(0) }}</li>
          <li class="content">
            <div class="from">{{ log.shopName }}</div>
            <div class="message editor">{{ log.message }}</div>
            <time>{{ log.createdTime }}</time>
          </li>
        </ul>
      </div>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import moment from "moment";
import SettingsHeader from "@/components/SettingsHeader.vue";
import apis from "@/services/apis";

export default {
  name: "home",
  data() {
    return {
      notifyLogs: [],
    };
  },
  components: {
    SettingsHeader,
    Header,
  },
  computed: {
    version() {
      return GLOBAL_ENV_VERSION;
    },
    userId() {
      return localStorage.getItem("lineUserId");
    },
  },
  methods: {
    getLogs() {
      return apis
        .getUserNotifyLogs(
          this.userId,
          this.$router.currentRoute.query.p,
          this.$router.currentRoute.query.s
        )
        .then((response) => {
          for (let i = 0; i < response.length; ++i) {
            response[i].createdTime = moment
              .unix(response[i].createdTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
          }
          this.notifyLogs = response;
        });
    },
  },
  mounted() {
    this.getLogs();
  },
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>
